module.exports = __webpack_public_path__ + "static/media/blank_tile.474cba7d.png";